// extracted by mini-css-extract-plugin
export default {"background":"AuthError_background__XVRgB","fadein":"AuthError_fadein__g+7dm","close":"AuthError_close__PWvQu"};